<template lang="html">
  <standard-dialog
    :width="500"
    color="secondary">
    <template #activator=" { on } ">
      <slot name="activator" :on="on">
        <v-btn v-on="on"> Activator </v-btn>
      </slot>
    </template>
    <template #main>
      <v-text-field
        :append-icon="passwordVisibility.old.icon"
        :type="passwordVisibility.old.type"
        v-model="oldPassword.value"
        prepend-icon="mdi-lock"
        label="Old Password"
        @click:append="oldPassword.show = !oldPassword.show"/>
      <v-text-field
        :append-icon="passwordVisibility.new.icon"
        :type="passwordVisibility.new.type"
        v-model="newPassword.value"
        prepend-icon="mdi-lock"
        label="New Password"
        @click:append="newPassword.show = !newPassword.show"/>
      <v-text-field
        :append-icon="passwordVisibility.confirm.icon"
        :type="passwordVisibility.confirm.type"
        v-model="confirmPassword.value"
        prepend-icon="mdi-check-all"
        label="Confirm New Password"
        @click:append="confirmPassword.show = !confirmPassword.show"/>
    </template>
    <template #actions=" { deactivate } ">
      <v-btn
        v-on="deactivate"
        @click="clearPasswords"
        color="secondary">
        Cancel
      </v-btn>
      <v-btn
        v-on="deactivate"
        @click="changePassword"
        color="primary"
        :loading="!!loading"
        :disabled="!!loading">
        Change Password
      </v-btn>
    </template>
  </standard-dialog>
</template>

<script>
import StandardDialog from './StandardDialog'
import ApiFactory from '@/api/ApiFactory'
import { mapGetters, mapActions } from 'vuex'
const UserApi = ApiFactory.get('users')

export default {
  components: {
    'standard-dialog': StandardDialog
  },
  data () {
    return {
      loading: false,
      oldPassword: {
        value: null,
        show: false
      },
      newPassword: {
        value: null,
        show: false
      },
      confirmPassword: {
        value: null,
        show: false
      }
    }
  },
  computed: {
    passwordVisibility () {
      const {
        getIcon,
        getType,
        oldPassword,
        newPassword,
        confirmPassword
      } = this;
      const oldPass = oldPassword.show
      const newPass = newPassword.show
      const confirmPass = confirmPassword.show
      return {
        old: { icon: getIcon(oldPass), type: getType(oldPass) },
        new: { icon: getIcon(newPass), type: getType(newPass) },
        confirm: { icon: getIcon(confirmPass), type: getType(confirmPass) }
      }
    },
    passwordsOk () {
      const oldPass = this.oldPassword.value
      const newPass = this.newPassword.value
      const confirm = this.confirmPassword.value
      return !!oldPass && !!newPass && !!confirm && (confirm === newPass)
    },
    ...mapGetters('user', [ 'id' ])
  },

  methods: {
    getIcon: val => !!val ? 'mdi-eye' : 'mdi-eye-off',
    getType: val => !!val ? 'text' : 'password',
    changePassword () {
      this.loading = true
      if (!this.passwordsOk) {
        this.raiseError({message: 'Verify that all fields are complete and passwords match'})
        this.loading = false
        return
      }
      const payload = {
        user: {
          password: this.newPassword.value
        },
        id: this.id,
        old_password: this.oldPassword.value
      }
      return UserApi.update(payload.id, payload).then(() => {
        this.loading = false
      }).catch(e => {
        if (e.response.status === 500) {
          this.raiseError({message: 'Make sure your password is at least 8 characters. If you keep seeing this message, let us know'})
        } else {
          this.raiseError(e)
        }
        this.loading = false
      })
    },
    clearPasswords () {
      this.oldPassword.value = null
      this.newPassword.value = null
      this.confirmPassword.value = null
    },
    ...mapActions('app', ['raiseError'])
  }
}
</script>

<style lang="css" scoped>
</style>
